import { render, staticRenderFns } from "./AgreementDocumentHeader.vue?vue&type=template&id=52954593&scoped=true"
import script from "./AgreementDocumentHeader.vue?vue&type=script&lang=js"
export * from "./AgreementDocumentHeader.vue?vue&type=script&lang=js"
import style0 from "./AgreementDocumentHeader.vue?vue&type=style&index=0&id=52954593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52954593",
  null
  
)

export default component.exports